// counter.actions.ts
import { Action } from '@ngrx/store';
import { Company } from '../models/company'

export const FETCH_SECTORS = '[Sector] FETCH_SECTORS';
export const FETCH_SECTORS_SUCCESS = '[Sector] FETCH_SECTORS_SUCCESS';
export const FETCH_SECTORS_FAILURE = '[Sector] FETCH_SECTORS_FAILURE';
export const CLEAR_SECTORS = '[Sector] CLEAR_SECTORS';

export class ClearSectors implements Action {
  readonly type = CLEAR_SECTORS;
  constructor() { }
}

export class FetchSectors implements Action {
  readonly type = FETCH_SECTORS;
  constructor() { }
}

export class FetchSectorsSuccess implements Action {
  readonly type = FETCH_SECTORS_SUCCESS;
  constructor(public payload: Company) {
  }
}

export class FetchSectorsFailure implements Action {
  readonly type = FETCH_SECTORS_FAILURE;
  constructor(public payload: any) {
  }
}

export type Actions = ClearSectors | FetchSectors | FetchSectorsSuccess | FetchSectorsFailure;



// WEBPACK FOOTER //
// ./src/actions/sector.actions.ts